import { render, staticRenderFns } from "./AlteracaoEncartes.vue?vue&type=template&id=2bf28769&scoped=true"
import script from "./AlteracaoEncartes.vue?vue&type=script&lang=js"
export * from "./AlteracaoEncartes.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoEncartes.vue?vue&type=style&index=0&id=2bf28769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf28769",
  null
  
)

export default component.exports